/**
 * PlotDataPanel - Presenter Component
 *
 * Pure presenter that renders the Plots data panel.
 * Receives panelConfig from PlotDataPanelContainer.
 * Contains ZERO store access.
 *
 * @see docs/adr/0034-container-presenter-component-pattern.md
 */

import React from 'react';
import type { Plot } from '../../../../types/types';
import { ConfigurableDataPanel, type ConfigurableDataPanelConfig } from '../../../../components/ConfigurableDataPanel/ConfigurableDataPanel';

export interface PlotDataPanelProps {
  panelConfig: ConfigurableDataPanelConfig<Plot>;
}

const PlotDataPanel: React.FC<PlotDataPanelProps> = ({ panelConfig }) => {
  return <ConfigurableDataPanel config={panelConfig} />;
};

export default PlotDataPanel;
